import ImportListProductGeneralTab from './ImportListProductGeneralTab'

export default ImportListProductGeneralTab
